// extracted by mini-css-extract-plugin
module.exports = {"logo":"Logo_logo__ID_iI","sm":"Logo_sm__j_TmU","lg":"Logo_lg__t3eGO"};